import { useRestaurant } from "../../context/restaurant-context";
import { isMobile } from "react-device-detect";
import { useUser } from "../../context/user-context";
import { Button } from "../../tabin/components/button";

import "./account.scss";
import { useAuth } from "../../context/auth-context";
import { useNavigate } from "react-router";
import { forgotPasswordPath } from "../main";

export const Account = () => {
    const { restaurant } = useRestaurant();
    const navigate = useNavigate();
    const { user } = useUser();
    const { logout } = useAuth();

    return (
        <div className="account-wrapper">
            <div className="bb-logo mb-2">
                <img
                    src="https://d1hfsnuz4i23pd.cloudfront.net/public/2024-08-28_03:59:03.132-361291020_657278139757168_5075971016856581513_n.webp"
                    width="100px"
                />
            </div>
            <div className="account-customer-name h3 mb-2">Hello {user?.firstName}!</div>
            <div
                className="account-button"
                onClick={() => {
                    navigate(forgotPasswordPath);
                }}
            >
                Change Password
            </div>
            <div
                className="account-button"
                onClick={() => {
                    window.location.href = "https://www.betterburger.co.nz/";
                }}
            >
                Terms and Conditions
            </div>
            <div
                className="account-button"
                onClick={() => {
                    window.location.href = "https://www.betterburger.co.nz/";
                }}
            >
                Privacy Policy
            </div>
            <div
                className="account-button"
                onClick={() => {
                    window.location.href = "https://www.betterburger.co.nz/";
                }}
            >
                Returns and Refunds
            </div>
            <div
                className="account-button"
                onClick={() => {
                    window.location.href = "https://www.betterburger.co.nz/";
                }}
            >
                More about Better Burger
            </div>
            <div className="account-button account-logout-button" onClick={() => logout()}>
                Log Out
            </div>
        </div>
    );
};
